<template>
  <div id="bet-card">
    <v-card class="white black--text mx-auto pt-1" flat>
      <!-- 
        Header Agente "Print Only" 
      -->
      <div class="d-print-block" v-if="agent">
        <h2 class="text-center py-2">{{ operator_name }}</h2>
        <v-divider light></v-divider>
        <div class="px-2">
          <v-row no-gutters>
            <v-col cols="6">
              <div class="overline pa-0">{{ $t("code") }}</div>
              <div class="pa-0 caption">{{ bet.id }}</div>
              <div class="overline pa-0">{{ $t("agent") }}</div>
              <div class="pa-0 caption">{{ agent.nome || "-" }}</div>
              <div class="overline pa-0">{{ $t("phone") }}</div>
              <div class="pa-0 caption">
                {{ agent.phone || agent.telephone || "-" }}
              </div>
            </v-col>
            <v-col cols="6">
              <div class="overline pa-0 d-flex align-center">
                {{ $t("schedule") }} ({{ $gmt() }})
              </div>
              <div class="pa-0 caption">
                {{ bet.date | dateFormat }}
              </div>
              <div class="overline pa-0">{{ $t("type") }}</div>
              <div class="pa-0 caption">{{ typeBet(bet.n_events) }}</div>
              <div class="overline pa-0">{{ $t("client") }}</div>
              <div class="pa-0 caption">{{ bet.punter || "-" }}</div>
            </v-col>
          </v-row>
          <v-row no-gutters v-if="level == 'administrator'">
            <!-- <v-col v-if="bet.ip != ''">
              <div class="overline pa-0">IP</div>
              <div class="pa-0 caption">{{ bet.ip }}</div>
            </v-col> -->
            <v-col v-if="bet.android_id != ''">
              <div class="overline pa-0">Android ID</div>
              <div class="pa-0 caption">{{ bet.android_id }}</div>
            </v-col>
          </v-row>
        </div>
        <v-divider light></v-divider>
      </div>
      <!-- 
        / End: Header "Print Only" 
      -->

      <!-- 
        Header Player 
      -->
      <div class="d-print-block" v-if="player">
        <h2 class="text-center py-2">{{ operator_name }}</h2>
        <v-divider light></v-divider>
        <div class="px-2 py-2">
          <v-row no-gutters>
            <v-col cols="6">
              <div class="overline pa-0">{{ $t("code") }}</div>
              <div class="pa-0 caption">{{ bet.id }}</div>
              <div class="overline pa-0">{{ $t("player") }}</div>
              <div class="pa-0 caption">{{ player.nome || "-" }}</div>
              <div class="overline pa-0">Login</div>
              <div class="pa-0 caption">
                {{ player.login }}
              </div>
            </v-col>
            <v-col cols="6">
              <div class="overline pa-0">
                {{ $t("schedule") }} ({{ $gmt() }})
              </div>
              <div class="pa-0 caption">
                {{ bet.date | dateFormat }}
              </div>
              <div class="overline pa-0">{{ $t("type") }}</div>
              <div class="pa-0 caption">{{ typeBet(bet.n_events) }}</div>
              <div class="overline pa-0">Id {{ $t("client") }}</div>
              <div class="pa-0 caption">{{ player.id }}</div>
            </v-col>
          </v-row>
        </div>
        <v-divider light></v-divider>
      </div>
      <!-- 
        / Header Player 
      -->

      <v-toolbar light flat tile class="flex-grow-0 d-print-none">
        <h3 class="font-weight-black">Nº {{ bet.id }}</h3>
        <div class="flex-grow-1"></div>
        <div class="pt-1 text-right" style="font-size: 12px">
          {{ bet.date | dateFormat }}
          <br />
        </div>
      </v-toolbar>
      <v-divider light class="d-print-none"></v-divider>
      <hr class="d-none d-print-block" />
      <v-card-text class="py-2 black--text">
        <v-subheader light class="px-0 d-flex justify-space-between">
          <div>{{ bet.n_events }} {{ $t("selection") }}</div>
          <div>odd</div>
        </v-subheader>
        <div>
          <div
            v-for="(event, index) in bet.events"
            :key="event.id"
            class="d-flex flex-column"
          >
            <v-divider
              light
              v-show="index"
              class="ml-8 pb-2 d-print-none"
            ></v-divider>
            <hr class="d-none d-print-block" />
            <div class="d-flex pb-2">
              <div class="pr-4 d-flex justify-center d-print-none">
                <v-icon light>mdi-circle-medium</v-icon>
              </div>
              <div class="flex-grow-1 d-flex flex-column mr-2">
                <div class="overline">
                  <!-- Torneio - {{ event.tournaments_name }} -->
                  {{ event.category_name }} - {{ event.tournaments_name }}
                </div>
                <div class="subtitle-2 font-weight-bold">
                  {{ $infoTable.outcomes(event.id_outcome).name_outcome }}
                </div>
                <div class="caption">
                  {{ $t("market") }}:
                  {{ $infoTable.markets(event.id_market).name_market }}
                </div>
                <div class="subtitle-2">
                  {{ event.description }}
                </div>
                <div class="caption">{{ event.scheduled | dateFormat }}</div>
              </div>
              <div class="d-flex flex-column justify-center align-end">
                <!-- Pre-Bet = (status_bet = '2')  -->
                <div
                  :class="
                    bet.status_bet === '2'
                      ? 'text-decoration-line-through grey--text'
                      : 'font-weight-black'
                  "
                >
                  {{ event.factor_event }}
                </div>

                <!-- Pre-Bet = (status_bet = '2')  -->
                <div v-if="bet.status_bet === '2'" class="font-weight-black">
                  {{ event.odd_price }}
                </div>

                <div
                  class="font-weight-black"
                  v-html="
                    $infoTable.conference(
                      event.result_event,
                      event.status_event
                    )
                  "
                ></div>

                <v-chip
                  class="ml-2 mb-1 font-weight-black"
                  small
                  color="primary"
                  v-if="event.live_event == '1'"
                >
                  {{ $t("live") }}
                </v-chip>

                <v-chip
                  class="ml-2 font-weight-black"
                  small
                  color="warning"
                  v-if="
                    legendActiveEvent[event.active_event] &&
                      event.status_event == 1 &&
                      level == 'administrator'
                  "
                >
                  {{ legendActiveEvent[event.active_event] }}
                </v-chip>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-divider light class="d-print-none"></v-divider>
      <hr class="d-none d-print-block" />
      <v-card-actions>
        <div
          class="d-flex align-center justify-center pl-1 pr-3 pt-2"
          v-if="valueQrcode"
        >
          <qrcode-vue
            :value="valueQrcode"
            :size="sizeQrcode"
            level="H"
            renderAs="svg"
          ></qrcode-vue>
        </div>
        <div class="d-flex flex-grow-1 flex-column body-2">
          <div class="d-flex justify-space-between align-center">
            <div>Total odds</div>
            <div>
              <!-- Pre-Bet = (status_bet = '2')  -->
              <span
                :class="
                  bet.status_bet === '2'
                    ? 'text-decoration-line-through grey--text'
                    : 'font-weight-black'
                "
                >{{ bet.factor_bet }}</span
              >
              <!-- Pre-Bet = (status_bet = '2')  -->
              <span v-if="bet.status_bet === '2'" class="font-weight-black"
                >&nbsp; {{ current_factor }}</span
              >
            </div>
          </div>
          <div class="d-flex justify-space-between align-center">
            <div>{{ $t("value") }}</div>
            <div class="font-weight-black">{{ bet.amount }}</div>
          </div>
          <div class="d-flex justify-space-between align-center">
            <div>{{ $t("possibleReturn") }}</div>
            <div>
              <!-- Apostas encerradas -->
              <div v-if="bet.result_bet == 2">
                <span class="text-decoration-line-through grey--text">{{
                  getPreviousBetValue(bet.amount, bet.factor_bet)
                }}</span>
                &nbsp;
                <span class="font-weight-black">{{ bet.prize }}</span>
              </div>
              <!-- Pre-Bet = (status_bet = '2')  -->
              <span
                v-else
                :class="
                  bet.status_bet === '2'
                    ? 'text-decoration-line-through grey--text'
                    : 'font-weight-black'
                "
                >{{ bet.prize }}</span
              >
              <span v-if="bet.status_bet === '2'" class="font-weight-black"
                >&nbsp; {{ current_prize }}</span
              >
            </div>
          </div>
          <div
            class="d-flex justify-space-between align-center"
            v-if="retailOne && agentHasPercentageInPrize"
          >
            <div>{{ $t("clientGains") }}</div>
            <div>
              <span
                :class="
                  bet.status_bet === '2'
                    ? 'text-decoration-line-through grey--text'
                    : 'font-weight-black'
                "
                >{{ (bet.prize - getClientGains(bet.prize)).toFixed(2) }}</span
              >
              <span v-if="bet.status_bet === '2'" class="font-weight-black"
                >&nbsp;
                {{
                  (current_prize - getClientGains(current_prize)).toFixed(2)
                }}</span
              >
            </div>
          </div>
          <div class="d-flex justify-space-between align-center">
            <div>{{ $t("conference") }}</div>
            <div
              class="font-weight-black"
              v-html="$infoTable.conference(bet.result_bet, bet.status_bet)"
            ></div>
          </div>
        </div>
      </v-card-actions>

      <!-- 
        Footer "Print Only" 
      -->
      <v-divider light></v-divider>
      <div class="d-print-block caption py-1">
        <div class="" v-if="bet.hash != ''">
          {{ bet.hash }}_{{ $route.path.split("/").pop() }}
        </div>
        <div class="">
          {{ $t("printingTime") }}: {{ $date.get.localeDateTime() }}
        </div>
        <div v-if="level == 'administrator' || level == 'collaborator'">
          <div v-if="bet.ip != ''">
            <div class="pa-0 caption">IP: {{ bet.ip }}</div>
          </div>
          <div v-if="bet.android_id != ''">
            <div class="pa-0 caption">Android ID: {{ bet.android_id }}</div>
          </div>
        </div>
        <div class="">
          {{ $operator.regulation_print }}
        </div>
        <v-divider light></v-divider>
        <div class="text-center">
          <div>{{ $t("prohibitedForUnder18") }}.</div>
          <br />
        </div>
      </div>
      <!-- 
        / End: Footer "Print Only" 
      -->
    </v-card>
  </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
export default {
  name: "betCard",
  components: {
    QrcodeVue,
  },
  data: () => ({
    sizeQrcode: 80,
    domain: localStorage.getItem("operator"),
    level: localStorage.getItem("level"),
  }),
  computed: {
    agentHasPercentageInPrize() {
      if (!this.agent || !this.retailOne) {
        return;
      }

      const { percentage_prize, events_prize } = this.agent;

      if (percentage_prize && events_prize) {
        if (percentage_prize > 0) {
          const { events } = this.bet;

          if (events.length >= events_prize) {
            return true;
          }
        }
      }

      return false;
    },
    retailOne() {
      return (
        this.$store.state.operator && this.$store.state.operator.retail == 1
      );
    },
    maxPrize() {
      return this.$store.state.operator.max_prize;
    },
    legendActiveEvent() {
      return {
        4: this.$t("canceledList"),
        5: this.$t("deferredList"),
        6: this.$t("canceledList"),
        7: this.$t("canceledList"),
      };
    },
    operator_name() {
      return this.$operator.operator_name;
    },
    // Bet
    bet() {
      return this.$store.state.betCard.betData;
    },
    agent() {
      return this.$store.state.betCard.agentData;
    },
    player() {
      return this.$store.state.betCard.playerData;
    },
    // mount qrcode
    valueQrcode() {
      if (this.bet.hash) {
        return `${this.bet.id}@${this.bet.hash.substring(0, 10)}`;
      } else {
        return false;
      }
    },
    // Current Factor (Only Pre-Bet)
    current_factor() {
      let events = this.bet.events;
      let current = 1;
      for (var i = 0; i < this.bet.n_events; i++) {
        current = current * Number(events[i].odd_price);
      }
      return this.decimalAdjustment(current);
    },
    // Current Prize (Only Pre-Bet)
    current_prize() {
      let current = this.current_factor * this.bet.amount;
      return this.decimalAdjustment(current);
    },
  },
  methods: {
    getPreviousBetValue(amount, odd) {
      const prize = amount * odd;

      if (prize > this.maxPrize) {
        return this.decimalAdjustment(this.maxPrize);
      }

      return this.decimalAdjustment(prize);
    },
    decimalAdjustment: function(num) {
      return -(Math.round(-num + "e+2") + "e-2");
    },
    typeBet: function(val) {
      const type = {
        "1": this.$t("simple"),
        "2": this.$t("double"),
        "3": this.$t("triple"),
      };
      if (val >= 4) return this.$t("multiple");
      return type[val];
    },

    getClientGains() {
      if (this.agentHasPercentageInPrize) {
        const { percentage_prize } = this.agent;
        const { prize } = this.bet;
        return parseFloat(((percentage_prize / 100) * prize).toFixed(2));
      }

      return 0;
    },
  },
  filters: {
    dateFormat: function(val) {
      var date = new Date(val.replace(" ", "T")).toLocaleString();
      return date;
    },
  },
};
</script>
